module.exports = __webpack_public_path__ + "static/media/animal_01_big.c7a64d9f.png";